// src/components/models/ModelFilter.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';

const ModelFilter = ({ brands, selectedBrandId, setSelectedBrandId }) => {
  const handleChange = (event) => {
    setSelectedBrandId(event.target.value);
  };

  return (
    <Box mb={2} display="flex" alignItems="center" gap={2}> 
    </Box>
  );
};

export default ModelFilter;
